<div class="w-full h-full flex flex-col items-center justify-center gap-4">

    <button (click)="registrarBienCultural(seccion_prehispanica)"
        *hasPermissions="'crear_bien_cultural_prehispanica' ; modulos ['CrearBienCultural']"
        class="border-2 md:border-[3px] rounded-2xl w-8/12 md:w-4/12 flex items-center h-14 md:h-20 p-2 
        md:p-6 cursor-pointer md:hover:border-[#f6e099] md:duration-200 md:hover:ease-in md:hover:scale-105">
        <div class="flex h-10 w-10 md:w-11 md:h-11 flex-0 items-center justify-center rounded-full sm:mr-4 bg-[#f6e099]">
            <mat-icon class="text-[#d49621] icon-size-6 md:icon-size-8" svgIcon="heroicons_outline:map"></mat-icon>
        </div>
        <span class="ml-3 text-sm md:text-2xl font-bold">Prehispánica</span>
    </button>

    <div (click)="registrarBienCultural(seccion_hispanica_republicana)"
        *hasPermissions="'crear_bien_cultural_hispanica_republicana' ; modulos ['CrearBienCultural']"
        class="border-2 md:border-[3px] rounded-2xl w-8/12 md:w-4/12 flex items-center h-14 md:h-20 
        p-2 md:p-6 cursor-pointer md:hover:border-[#dea5de] md:duration-200 md:hover:ease-in md:hover:scale-105">
        <div class="flex h-10 w-10 md:w-11 md:h-11 flex-0 items-center justify-center rounded-full sm:mr-4 bg-[#f6dff6]">
            <mat-icon class="text-[#c546d9] icon-size-6 md:icon-size-8" svgIcon="heroicons_outline:map"></mat-icon>
        </div>
        <span class="ml-3 text-sm md:text-2xl font-bold">Hispánica Republicana</span>
    </div>

    <div (click)="registrarBienCultural(seccion_bienes_inmuebles)"
        *hasPermissions="'crear_bien_cultural_bienes_inmuebles' ; modulos ['CrearBienCultural']"
        class="border-2 md:border-[3px] rounded-2xl w-8/12 md:w-4/12 flex items-center h-14 md:h-20 
        p-2 md:p-6 cursor-pointer md:hover:border-[#e2d6b6] md:duration-200 md:hover:ease-in md:hover:scale-105">
        <div class="flex h-10 w-10 md:w-11 md:h-11 flex-0 items-center justify-center rounded-full sm:mr-4 bg-[#e2d6b6]">
            <mat-icon class="text-[#be8e35] icon-size-6 md:icon-size-8" svgIcon="heroicons_outline:map"></mat-icon>
        </div>
        <span class="ml-3 text-sm md:text-2xl font-bold">Bienes Inmuebles</span>
    </div>

</div>